import {shouldRetryQuery} from './expected-error'
import {isWeb} from '@/src/shared/utils/functions'
import {defaultShouldDehydrateQuery, QueryClient} from '@tanstack/react-query'
import {cache} from 'react'

let browserQueryClient: QueryClient | undefined = undefined

export const getQueryClient = cache(function () {
  const newQueryClient = function () {
    return new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          refetchInterval: 0,
          refetchOnReconnect: false,
          retry: shouldRetryQuery,
        },
        dehydrate: {
          // include pending queries in dehydration
          shouldDehydrateQuery: query => defaultShouldDehydrateQuery(query),
        },
      },
    })
  }

  if (isWeb() && typeof window === 'undefined') {
    // Server: always make a new query client
    return newQueryClient()
  } else {
    // Browser: make a new query client if we don't already have one
    // This is very important, so we don't re-make a new client if React
    // suspends during the initial render. This may not be needed if we
    // have a suspense boundary BELOW the creation of the query client
    if (!browserQueryClient) browserQueryClient = newQueryClient()
    return browserQueryClient
  }
})
